'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  ', '\n  ', '\n  font-family: \'Nunito Sans\', \'Helvetica Neue\', HelveticaNeue, Helvetica, Arial, sans-serif;\n  margin: 0px;\n'], ['\n  ', '\n  ', '\n  ', '\n  font-family: \'Nunito Sans\', \'Helvetica Neue\', HelveticaNeue, Helvetica, Arial, sans-serif;\n  margin: 0px;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _colors = require('../../../behaviors/colors');
var _fontSize = require('../../../behaviors/fontSize');
var _fontWeight = require('../../../behaviors/fontWeight');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var InnerStyledText = _styledComponents2.default.div(_templateObject, _colors.withTextColor, _fontSize.withTextSize, _fontWeight.withTextWeight);

// https://styled-components.com/docs/api#as-polymorphic-prop
var StyledText = function StyledText(_ref) {
  var lurker = _ref.lurker,
    tag = _ref.tag,
    props = (0, _objectWithoutProperties3.default)(_ref, ['lurker', 'tag']);
  return _react2.default.createElement(InnerStyledText, (0, _extends3.default)({
    'data-lurker-detail': lurker,
    as: tag
  }, props));
};
StyledText.propTypes = {
  lurker: _propTypes2.default.string,
  // deprecated prop lurker
  'data-lurker-detail': _propTypes2.default.string,
  // lurker property to track click with given object detail
  tag: _propTypes2.default.string
};
exports.default = StyledText;